/* Desktop disclosure behavior; Dawn continues to handle the mobile drawer. */
document.querySelectorAll('.nova-nav').forEach((nav) => {
  const disclosures = [...nav.querySelectorAll('details')];
  const close = (details) => {
    details.open = false;
    details.querySelector('summary').setAttribute('aria-expanded', 'false');
  };
  disclosures.forEach((details) => {
    const summary = details.querySelector('summary');
    summary.setAttribute('aria-expanded', String(details.open));
    details.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(details.open));
      if (details.open) disclosures.filter((other) => other !== details).forEach(close);
    });
    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        close(details);
        summary.focus();
      }
    });
    details.parentElement.addEventListener('focusout', (event) => {
      if (!details.parentElement.contains(event.relatedTarget)) close(details);
    });
  });
  document.addEventListener('click', (event) => {
    if (!nav.contains(event.target)) disclosures.forEach(close);
  });
  window.addEventListener('scroll', () => disclosures.forEach(close), { passive: true });
  window.matchMedia('(max-width: 989px)').addEventListener('change', () => disclosures.forEach(close));
});
